import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator'
import PopupModal from '@/components/common/Modal/PopupModal.vue'
import { mapGetters, mapMutations } from 'vuex'

import * as types from '@workflow/store/types'

@Component({
    name: 'ApprovalProcessingModal',
    components: { PopupModal },
    computed: {
        ...mapGetters({
            formData: types.WORKFLOW_CURRENT,
        }),
    },
    methods: {
        ...mapMutations({
            
        })
    }
})
export default class CommentModal extends Vue {

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean }) show!: boolean
    
    //@Prop({ type: Object }) formData!: any


    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    CommentList:any = [];

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    formData!: workflow.CM_Form

    //
    // ──────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y L C L E : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────────
    //

    created(){
         this.CommentList = this.formData?.approvalLineList?.filter((x:any) => x.approverComment);
    }
    
}
